module.exports = __webpack_public_path__ + "media/images/emoticons/toilet-a2d8a31c8f43d2f8af512579820b97e0.gif";